"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBroadcastRecipientDto = instanceOfBroadcastRecipientDto;
exports.BroadcastRecipientDtoFromJSON = BroadcastRecipientDtoFromJSON;
exports.BroadcastRecipientDtoFromJSONTyped = BroadcastRecipientDtoFromJSONTyped;
exports.BroadcastRecipientDtoToJSON = BroadcastRecipientDtoToJSON;
exports.BroadcastRecipientDtoToJSONTyped = BroadcastRecipientDtoToJSONTyped;
/**
 * Check if a given object implements the BroadcastRecipientDto interface.
 */
function instanceOfBroadcastRecipientDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function BroadcastRecipientDtoFromJSON(json) {
    return BroadcastRecipientDtoFromJSONTyped(json, false);
}
function BroadcastRecipientDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}
function BroadcastRecipientDtoToJSON(json) {
    return BroadcastRecipientDtoToJSONTyped(json, false);
}
function BroadcastRecipientDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
    };
}
